const REPORT_OF_TYPE = {
  BATCH: 'BATCH',
  DATE: 'DATE',
}

const EXPORT_STATUS_TYPE = {
  PROCESSED: 'PROCESSED',
  PROCESSING: 'PROCESSING',
  ERROR: 'ERROR',
}

const statusName = {
  [EXPORT_STATUS_TYPE.PROCESSED]: 'Processado',
  [EXPORT_STATUS_TYPE.PROCESSING]: 'Processando',
  [EXPORT_STATUS_TYPE.ERROR]: 'Erro',
}

const translateExportStatus = (key) => {
  return statusName[key] || key
}


export {
  EXPORT_STATUS_TYPE,
  REPORT_OF_TYPE,
  translateExportStatus,
}
